import Component from "@glimmer/component";
import { action } from "@ember/object";
import DButton from "discourse/ui-kit/d-button";
import { service } from "@ember/service";
import { clipboardCopy } from "discourse/lib/utilities";

export default class WazeCopyTemplateButton extends Component {
  @service wazeSnackbar;

  @action
  copyTemplateToClipboard() {
    const post = this.args.post;
    const copiedText = `[wzTemplate topic=${post.topic_id} post=${post.post_number}][/wzTemplate]`;
    clipboardCopy(copiedText)
      .then(() => {
        this.wazeSnackbar.show(
          "waze.templates.copy_template_snackbar.description",
        );
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Failed to copy template to clipboard: ", err);
      });
  }

  <template>
    <DButton
      ...attributes
      @action={{this.copyTemplateToClipboard}}
      @icon="w-copy"
      @title="waze.templates.copy_template_button.description"
    />
  </template>
}
